<script>
    import "tabulator-tables/dist/css/tabulator.min.css";

    import { fetchGet } from "../utils/utilsFetch.js";

    import { addToCart, getCart } from "../utils/utils.js";

    import { isLoading, cart, client, locale } from "../stores.js";

    export let sku;

    let quantity;

    let product, description;

    let quantityField;

    async function getProduct(sku) {
        $isLoading = true;

        product = null;

        [product, description] = await Promise.all([
            fetchGet(`/api/products?sku=${sku}`),
            fetchGet(`/api/products/${sku}/description`),
        ]);

        quantity = product.cartQuantity;

        $isLoading = false;
    }

    $: getProduct(sku);

    $: if (quantityField) {
        quantityField.focus();
    }
</script>

<div class="container">
    {#if product}
        <div class="pic">
            <img src="/pics/all/{sku}.jpg" />
        </div>

        <div class="info">
            <div class="title">
                {product.productName}
            </div>

            <div class="info-item">
                <div class="label">{$locale.sku || ""}:</div>
                {product.sku}
            </div>

            {#if !$client.isHiddenPrices}
                <br />

                <div class="info-item">
                    <div class="label">{$locale.priceWithVat || ""}:</div>
                    {product.priceWithVat}
                </div>

                <div class="info-item">
                    <div class="label">{$locale.priceWithoutVat || ""}:</div>
                    {product.priceWithoutVat}
                </div>

                <br />

                <div class="info-item">
                    <div class="label">{$locale.discount || ""}:</div>
                    {product.discount}%
                </div>

                <br />

                <div class="info-item">
                    <div class="label">{$locale.priceWithoutVat || ""}:</div>
                    {product.clientPriceWithoutVat}
                </div>

                <div class="info-item">
                    <div class="label">{$locale.priceWithVat || ""}:</div>
                    {product.clientPriceWithVat}
                </div>
            {/if}

            <br />

            <div class="info-item">
                <div class="label">{$locale.packaging || ""}:</div>
                {product.packaging}
            </div>

            <br />

            <div class="info-item">
                <div class="label">{$locale.barcodes || ""}:</div>
                {product.barcodes}
            </div>

            <br />

            <div class="info-item">
                <div class="label">{$locale.stock || ""}:</div>
                <span
                    class:red={product.stockHidden ==
                        ($locale.noStock || "Нема")}
                >
                    {product.stockHidden}
                </span>
            </div>

            <br />

            <div class="info-item">
                <div class="label">{$locale.order || ""}:</div>
                <input
                    bind:this={quantityField}
                    style="width: 100px; margin-right: 20px;"
                    bind:value={quantity}
                    on:keyup={async (e) => {
                        addToCart(sku, quantity);
                        $cart = await getCart();
                    }}
                />
            </div>

            <br />

            {#if description}
                {#if description.shortDescription}
                    <div class="description">
                        {@html description.shortDescription}
                    </div>
                {/if}

                <br />

                {#if description.fullDescription}
                    <div class="description">
                        {@html description.fullDescription}
                    </div>
                {/if}
            {/if}
        </div>
    {/if}
</div>

<style>
    .container {
        padding: 10px;
        display: flex;
        height: 100%;
    }

    .pic {
        width: 500px;
        margin-right: 30px;
    }

    .pic img {
        width: 100%;
    }

    .title {
        font-size: 20px;
        font-weight: bold;
        margin-bottom: 20px;
    }

    .info {
        display: flex;
        flex-direction: column;
        height: 100%;
        overflow: auto;
    }

    .info-item {
        display: flex;
        align-items: center;
    }

    .label {
        width: 180px;
        margin-right: 10px;
        font-weight: bold;
    }

    .red {
        color: red;
        font-weight: bold;
    }

    @media only screen and (max-device-width: 600px) {
        .container {
            flex-direction: column;
            gap: 20px;
        }

        .pic {
            width: 100%;
            height: 140px;
        }

        .pic img {
            object-fit: contain;
            width: 100%;
            height: 100%;
        }
    }
</style>
